export const filterTypes = {
  categories: 'categories',
  dates: 'dates',
  locations: 'locations',
  view: 'view',
}

export const filters = [filterTypes.dates, filterTypes.categories, filterTypes.locations, filterTypes.view]